import { render } from "./views/app/app.html?vue&type=template&id=10fff8dc&scoped=true&ts=true"
import script from "./views/app/app.ts?vue&type=script&lang=ts"
export * from "./views/app/app.ts?vue&type=script&lang=ts"

import "./views/app/global.scss?vue&type=style&index=0&lang=scss"
import "./views/app/app.scss?vue&type=style&index=1&id=10fff8dc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fff8dc"]])

export default __exports__